/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  notesWrapper: {
    margin: 10,
  },
  notesHeading: {
    fontWeight: "bold",
    fontSize: "12px",
  },
  notesText: {
    fontSize: "9px",
    marginTop: 5,
  },
});

const Notes = ({ billingInformation }: any) => (
  <View style={styles.notesWrapper}>
    <Text style={styles.notesHeading}>Notes: </Text>
    <Text style={styles.notesText}>{billingInformation?.notes}</Text>{" "}
  </View>
);

export default Notes;
